import baseModel from './index';

class ConfigModel extends baseModel {

  // =============
  // CONSTRUCTOR
  // =============

  constructor(state) {
    super(state);
    this.initState(state);
  }

  // ===============
  // CLASS METHODS
  // set default properties here
  // ===============

  static defaultState() {
    return {
      configData: {}
    };
  }



  // =====================
  // INTERFACING METHODS
  // init all the sates
  // =====================

  initState(state) {
    this.state = Object.assign(this.constructor.defaultState(), state);
    if (state.dataConfiguration && state.dataConfiguration.length > 0) {
      this.state.pageConfiguration = state.dataConfiguration.map(x => (
        {
          'key': x.key,
          'value': x.value,
          'configuration': x.configuration
        }));
      this.state.configData = this.constructor.parseConfigData(this.state.pageConfiguration, this.state.globalNavigation, state.isEYPValidUser);
    }
  }


  // =====================
  // parse all configuration data
  // =====================

  static parseConfigData(pageConfiguration, globalNavigation, isEYPValidUser) {
    let configData = {};
    configData.isEYPValidUser = isEYPValidUser;
    for (let i = 0; i < pageConfiguration.length; i += 1) {
      if (`${pageConfiguration[i].key}` === "HeaderConfiguration") {
        configData = { ...configData, ...this.buildHeaderConfig(pageConfiguration[i], globalNavigation) };
      }
      else {
        configData = { ...configData, ...this.buildOtherConfig(pageConfiguration[i]) };
      }
    }
    return configData;
  }


  // =====================
  // create header configuration 
  // return config
  // =====================

  static buildHeaderConfig(config, globalNavigationConfig) {
    const mainMenuItems = [];
    let configData = {};
    const appArray = [];
    const value = JSON.parse(config.value);
    if (config.key && config.key.length > 0) {
      const configMainMenu = JSON.parse(config.value);
      configData = {
        ...{ menuConfiguration: [] },
        ...{ submit: "" },
        ...{ headerLogo: value && value.logo },
        ...{ apps: [] }
      };
      for (let j = 0; j < configMainMenu.globalNavigation.length; j += 1) {
        const menuItems = {
          'mainMenu': configMainMenu.globalNavigation[j].title,
          'openInNewTab': configMainMenu.globalNavigation[j].openInNewTab,
          'url': configMainMenu.globalNavigation[j].url,
          'subMenu': this.getSubMenuItems(globalNavigationConfig, configMainMenu.globalNavigation[j].siteCategory.toLowerCase()),
          'id': configMainMenu.globalNavigation[j].id
        };
        if (menuItems.url !== "" || menuItems.subMenu.length > 0) {
          mainMenuItems.push(menuItems);
        }
      }
      configData.menuConfiguration = mainMenuItems;
      // Condition to check the main menu array contains submit 
      if (configData.menuConfiguration.findIndex(menuItem => menuItem.id === "submit") < 0 && value && value.submit && value.submit.url) {
        configData.submit = value && value.submit
      }
      // Condition to remove the apps without URL
      if (value.apps && value.apps.length > 0) {
        value.apps.forEach(element => {
          if (element.url !== "") {
            appArray.push(element)
          }

        });
      }
      configData.apps = appArray;
    }
    return configData;
  }


  // =====================
  // build other all configurations
  // =====================

  static buildOtherConfig(config) {
    const configData = {};
    let value = {};
    try {
      value = JSON.parse(config.value);
    } catch (e) {
      value = config.value;
    }
    configData[config.key] = value;
    return configData;
  }


  // =====================
  // create sub menu items for refiners
  // =====================
  static getSubMenuItems(subMenuConfiguration, siteCategory) {
    let subMenuItems = [];
    if (subMenuConfiguration && subMenuConfiguration.length > 0 && siteCategory) {

      subMenuItems = subMenuConfiguration.filter((subMenuObj) => subMenuObj && subMenuObj.siteCategory && subMenuObj.siteCategory.toLowerCase() === siteCategory.toLowerCase())
        .sort((a, b) => Number(a.subMenuOrder) - Number(b.subMenuOrder));

      // let j = 0;
      // for (j = 0; j < subMenuConfiguration.length; j += 1) {
      //   if (subMenuConfiguration[j].siteCategory !== null && subMenuConfiguration[j].siteCategory !== ''
      //     && subMenuConfiguration[j].siteCategory && subMenuConfiguration[j].siteCategory.toLowerCase() === siteCategory) {
      //     subMenuItems.push([subMenuConfiguration[j].title, subMenuConfiguration[j].newTab, subMenuConfiguration[j].link]);
      //   }
      // }
    }
    return subMenuItems;
  }


}

export default ConfigModel;